import * as types from '../../index';


export const skillListAction = (data) => {
    return {
    type: types.SUPERADMIN_SKILL_LIST,
    data
    }
};


export const skillAddAction = (data) => {
    return {
    type: types.SUPERADMIN_SKILL_ADD,
    data
    }
};

export const skillEditAction = (data) => {
    return {
    type: types.SUPERADMIN_SKILL_EDIT,
    data
    }
};

export const skillUpdateAction = (data) => {
    return {
    type: types.SUPERADMIN_SKILL_UPDATE,
    data
    }
};

export const skillDeleteAction = (data) => {
    return {
    type: types.SUPERADMIN_SKILL_DELETE,
    data
    }
};

export const subSectorListAction = (data) => {
    return {
    type: types.SUPERADMIN_SUBSECTOR_LIST,
    data
    }
};